import {ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {
  IPlatformToolComponent,
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {Subject} from 'rxjs';
import {PlatformCommandResponse} from '@shared/commands/command-base';
import {IconViewModel} from '@features/file-manager/models/file-manager.model';
import {FileStoreCommonService} from '@features/file-manager/services/file-store-common.service';

@Component({
    standalone: false,
    selector: 'app-file-store-root-view',
  templateUrl: './file-store-root-view.component.html',
  styleUrls: ['./file-store-root-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FileStoreRootViewComponent implements OnInit, OnDestroy, IPlatformToolComponent {
  @Input() magicLinkModel: MagicLinkModel;
  @Input() handler: IPlatformToolHandler;
  @Input() selectedTab: TabModel;
  @Input() invalidateSubject: InvalidateSubject = new InvalidateSubject();
  public isClientDrive = true;
  public unsubscribe$ = new Subject<void>();
  isReady = false;

  constructor(@Inject(ChangeDetectorRef) private cdRef: ChangeDetectorRef,
              private fileStoreCommonService: FileStoreCommonService) {
  }

  ngOnInit(): void {
    console.log('[FileStoreRootViewComponent]', this.magicLinkModel);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  onAfterExecuteNextCommand(nextCommandResponse: PlatformCommandResponse) {
  }

  onAfterExecutePreviousCommand(previousCommandResponse: PlatformCommandResponse) {
  }

  onBeforeExecuteNextCommand(): boolean {
    return true;
  }

  onBeforeExecutePreviousCommand(): boolean {
    return true;
  }

  onLoad() {

  }

  iconViewItemClicked($event: IconViewModel) {
    this.fileStoreCommonService.executeFormAdditionalCommand({
      itemId: $event.itemId,
      parentId: $event.parentId,
      driveId: $event.driveId
    }, $event.type, this.magicLinkModel);
  }
}
